import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import {
    constantRouterMap
} from '@/config/router'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRouterMap
})

router.beforeEach((to, from, next) => {
    var appToken = sessionStorage.getItem('token')
    if (to.path === '/user/login') {
        if (appToken) {
            next({ name: 'dashboard' })
        } else {
            next()
        }
    } else {
        if (appToken) {
            if (store.state.app.addRouters.length === 0) {
                store.commit('setAsyncRouterMap')
                router.addRoutes(store.state.app.addRouters)
                const redirect = decodeURIComponent(from.query.redirect || to.path)
                if (to.path === redirect) {
                    // hack方法 确保addRoutes已完成
                    next({ ...to, replace: true })
                } else {
                    // 跳转到目的路由
                    next({ path: redirect })
                }
            } else {
                next()
            }
        } else {
            next({ path: `/user/login?redirect=${to.fullPath}` })
        }
    }
})
export default router
